import React, { useEffect, useRef } from 'react';

const FormError = ({ message }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (message) {
      ref.current?.focus({ preventScroll: true });
      ref.current?.scrollIntoView({ block: 'center', behavior: 'instant' });
    }
  }, [message]);

  if (!message) return null;
  return (
    <div ref={ref} role="alert" tabIndex={-1}
      className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700 scroll-mt-24">
      {message}
    </div>
  );
};

export default FormError;
